import React from 'react';
import RefineryImg from '../../../assets/images/Refinery29-logo.png';
import UnbotheredImg from '../../../assets/images/Unbothered-logo.png';
import SomosImg from '../../../assets/images/Somos-logo.png';
import BeautyconImg from '../../../assets/images/Beautycon-logo.png';
import UnbotheredMenu from '../../../assets/images/Unbothered-logo-menu.png';
import SomosMenu from '../../../assets/images/Somos-logo-menu.png';
import BeautyconMenu from '../../../assets/images/Beautycon-logo-menu.png';

export const UnbotheredLogo = (<img className="menu-logo" src={UnbotheredImg}/>);

export const SomosLogo = (<img className="menu-logo" src={SomosImg}/>);

export const BeautyconLogo = (<img className="menu-logo" src={BeautyconImg}/>);

export const RefineryLogo = (<img className="menu-logo" src={RefineryImg}/>);

export const UnbotheredMenuLogo = (<img className="menu-logo" src={UnbotheredMenu}/>);

export const SomosMenuLogo = (<img className="menu-logo" src={SomosMenu}/>);

export const BeautyconMenuLogo = (<img className="menu-logo" src={BeautyconMenu}/>);
